// @flow @jsx h

import { h } from 'preact'
import styles from './Button.css'
import { bem } from '@nrk/dh-utils'

type Props = {
  href?: string,
  onClick: (e: Event) => void,
  modifiers?: Array<string | false>,
  invert?: boolean,
  children: any
}

const Button = ({
  href,
  onClick,
  modifiers = [],
  children,
  ...rest
}: Props) => {
  if (!modifiers || modifiers.length === 0) {
    modifiers = ['regular']
  }
  if (href) {
    return (
      <a
        class={['nrk-button', bem(styles.button, ...modifiers)].join(' ')}
        href={href}
        {...rest}
      >
        {children}
      </a>
    )
  }
  return (
    <button
      class={['nrk-button', bem(styles.button, ...modifiers)].join(' ')}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  )
}

export { Button }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/common/Button.js